const docTypes = ['concept', 'reference', 'howto', 'releasenote']

const docTypesPretty = {
    'howto': 'How-to',
    'reference': 'Reference',
    'concept': 'Concept',
    'releasenote': 'Release Note'
}

module.exports = {
    docTypes,
    docTypesPretty
}
